import { useState } from 'react';

export default function WhichApplies() {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const scenarios = [
    {
      icon: 'ri-tooth-line',
      title: 'Missing One or More Teeth',
      description: 'Gaps in your smile affecting confidence and chewing ability'
    },
    {
      icon: 'ri-emotion-unhappy-line',
      title: 'Uncomfortable Dentures',
      description: 'Loose, slipping dentures causing discomfort and embarrassment'
    },
    {
      icon: 'ri-alert-line',
      title: 'Damaged or Failing Teeth',
      description: 'Teeth beyond repair that need extraction and replacement'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Bone Loss Concerns',
      description: 'Worried about jawbone deterioration from missing teeth'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Difficulty Eating',
      description: 'Unable to enjoy your favorite foods due to missing teeth'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Want a Permanent Solution',
      description: 'Looking for a long-lasting, natural-looking tooth replacement'
    }
  ];

  const itemsPerView = 3;
  const maxIndex = scenarios.length - itemsPerView;

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(maxIndex, prev + 1));
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#F5F5F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-4">
            Which Of These <strong>Applies To You?</strong>
          </h2>
          <div className="w-24 h-1 bg-[#D0A24F] mx-auto mt-6"></div>
        </div>

        {/* Desktop Carousel View */}
        <div className="hidden md:block relative">
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-in-out gap-8"
              style={{ transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)` }}
            >
              {scenarios.map((scenario, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-[#D0A24F]"
                  style={{ width: `calc((100% - 4rem) / ${itemsPerView})` }}
                >
                  <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
                    <i className={`${scenario.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#444c42] mb-3">
                    {scenario.title}
                  </h3>
                  <p className="text-base text-[#7A8178] leading-relaxed">
                    {scenario.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className={`absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center transition-all cursor-pointer ${
              currentIndex === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#D0A24F] hover:text-white'
            }`}
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <button
            onClick={handleNext}
            disabled={currentIndex === maxIndex}
            className={`absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center transition-all cursor-pointer ${
              currentIndex === maxIndex ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#D0A24F] hover:text-white'
            }`}
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>
        </div>

        {/* Mobile Grid View */}
        <div className="grid grid-cols-1 md:hidden gap-8">
          {scenarios.map((scenario, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-[#D0A24F]"
            >
              <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
                <i className={`${scenario.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#444c42] mb-3">
                {scenario.title}
              </h3>
              <p className="text-base text-[#7A8178] leading-relaxed">
                {scenario.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-[#444c42] mb-6 font-semibold">
            If any of these sound familiar, dental implants could be the perfect solution for you.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('booking');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-[#D0A24F] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#F5d383] transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            Book Your Free Consultation
          </button>
        </div>
      </div>
    </section>
  );
}
